export const FINANCE_PAGE_MODULES = [
    'header',
    'ask-input',
    'mini-graphs',
    'watchlist',
    'market-summary',
    'financial-profile',
];
export const FINANCE_INDEX_PAGE_MODULE = [
    'ask-input',
    'mini-graphs',
    'watchlist',
    'financial-profile',
];
export const HOME_PAGE_MODULES = ['ask-input'];
export const THREAD_PAGE_MODULES = [
    'thread-first-content-rendered',
];
export const LIBRARY_PAGE_MODULES = ['library-threads-loaded'];
export const SPACES_PAGE_MODULES = ['ask-input', 'article-list'];
export const DISCOVER_INDEX_PAGE_MODULES = ['topic-list'];
export const ARTICLE_PAGE_MODULES = ['article-page-loaded'];
export const SPACES_INDEX_PAGE_MODULES = [
    'spaces-page-loaded',
];
export const ACADEMIC_PAGE_MODULES = ['academic-page-rendered'];
export const PERPLEXIFY_ME_PAGE_MODULES = [
    'perplexify-me-page-rendered',
];
export const PATENTS_PAGE_MODULES = ['patents-page-rendered'];
export const SECURITY_INDEX_PAGE_MODULES = [
    'security-index-loaded',
];
export const SECURITY_SOURCE_DETAIL_PAGE_MODULES = [
    'security-source-detail-loaded',
];
export const COMPUTER_AUTOMATIONS_PAGE_MODULES = [
    'computer-automations-page-rendered',
];
export const COMET_ZEN_PAGE_MODULES = [
    'comet-zen-page-rendered',
];
export const CLOUD_PICKER_PAGE_MODULES = [
    'cloud-picker-page-ready',
];
export const ACCOUNT_SETTINGS_PAGE_MODULES = [
    'account-settings-route-rendered',
];
export const NOVA_PAGE_MODULES = ['nova-page-rendered'];
export const NOVA_WORKSPACE_PAGE_MODULE = 'nova-workspace-project-rendered';
export const NOVA_WORKSPACE_PAGE_MODULES = [
    NOVA_WORKSPACE_PAGE_MODULE,
];
export const SIDECAR_SPEAK_PAGE_MODULES = [
    'sidecar-speak-rendered',
];
export const MOBILE_SIDECAR_SPEAK_PAGE_MODULES = [
    'mobile-sidecar-speak-rendered',
];
export const VOICE_ASSISTANT_PAGE_MODULES = [
    'voice-assistant-rendered',
];
export const SPA_AUX_PAGE_RENDERED_MODULE = 'spa-aux-page-rendered';
export const SPA_AUX_PAGE_MODULES = [SPA_AUX_PAGE_RENDERED_MODULE];
export const HEALTH_OVERVIEW_PAGE_MODULES = [
    'health-dashboard-query',
    'health-insights-query',
    'health-activity-logs-query',
    'health-fitness-query',
    'health-discover-articles-query',
    'health-explore-loaded',
];
export const HEALTH_DASHBOARD_PAGE_MODULES = [
    'health-vitals',
    'health-biomarkers',
];
export const HEALTH_HISTORY_PAGE_MODULES = [
    'health-history-loaded',
    'health-recent-creations-query',
];
export const HEALTH_GALLERY_PAGE_MODULES = [
    'health-gallery-loaded',
];
export const COMPUTER_THREAD_PAGE_MODULES = [
    'computer-thread-fetched',
    'computer-thread-rendered',
];
export const COMPUTER_TASK_PAGE_MODULES = [
    'computer-task-first-content-rendered',
];
export const COMPUTER_DASHBOARD_PAGE_MODULES = [
    'computer-dashboard-loaded',
];
export const COMPUTER_LANDING_MODULES = [
    'computer-landing-rendered',
];
export const COMPUTER_LOADING_MODULES = [
    'computer-loading-rendered',
];
export const COMPUTER_GALLERY_MODULES = [
    'computer-gallery-rendered',
];
export const COMPUTER_ARTIFACTS_MODULES = [
    'computer-artifacts-rendered',
    'computer-artifacts-data-ready',
];
export const COMPUTER_ASSET_MODULES = [
    'computer-asset-rendered',
];
export const COMPUTER_SKILLS_MODULES = [
    'computer-skills-rendered',
];
export const COMPUTER_SKILL_DETAIL_RENDERED_MODULE = 'computer-skill-detail-rendered';
export const COMPUTER_SKILL_DETAIL_MODULES = [
    COMPUTER_SKILL_DETAIL_RENDERED_MODULE,
];
export const COMPUTER_PLUGINS_MODULES = [
    'computer-plugins-rendered',
];
export const COMPUTER_PLUGIN_DETAIL_RENDERED_MODULE = 'computer-plugin-detail-rendered';
export const COMPUTER_PLUGIN_DETAIL_MODULES = [
    COMPUTER_PLUGIN_DETAIL_RENDERED_MODULE,
];
export const COMPUTER_CONNECTOR_DETAIL_RENDERED_MODULE = 'computer-connector-detail-rendered';
export const COMPUTER_CONNECTOR_DETAIL_MODULES = [
    COMPUTER_CONNECTOR_DETAIL_RENDERED_MODULE,
];
export const COMPUTER_WORKFLOWS_MODULES = [
    'computer-workflows-rendered',
];
export const COMPUTER_MEMORY_MODULES = [
    'computer-memory-rendered',
];
export const COMPUTER_CONNECTORS_MODULES = [
    'computer-connectors-rendered',
];
//# sourceMappingURL=pageTTVModules.js.map